exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".custom-btn strong{margin:0 5px;color:red;vertical-align:text-bottom}.custom-btn>a{color:#290202;font-weight:700}.custom-btn>a:hover{color:#ec1c1c;text-decoration:none}.expand-icon-style{display:inline-block;width:22px;color:red;margin-right:5px;cursor:pointer}.expand-icon-style i{font-size:18px;vertical-align:middle;margin-top:-2px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"minimize":true,"importLoaders":0,"alias":{"/assets":"/opt/nodeapps/svndata/jzq-web/assets","/static":"/opt/nodeapps/svndata/jzq-web/static"}}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-d014d538","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./pages/console/organization.vue
// module id = cCAb
// module chunks = 7 40 160